export const HC_ROOT_PATH = '/help'
export const HC_RECENT_TRANSACTIONS_PATH = '/help/recent_transactions'
export const HC_TRANSACTION_PATH = (transactionId: number) =>
  `/help/for_transaction/${transactionId}`
export const HC_FAQ_PATH = (faqPath: string) => `/help/${faqPath}`
